import React from "react";
import Icon from "../Icon";
import { Button, Pill, Spinner } from "../primitives";

/** Apply / Applied (tap withdraws) / Joined / inactive, from joinStateFor(). `testId` lands on the tappable button. */
export default function JoinButton({ state, busy = false, onPress, size = "xs", testId }) {
  if (state === "joined") return <Pill tone="green" icon="check">Joined</Pill>;
  if (state === "inactive") return <Pill tone="gray">Not active</Pill>;
  if (busy) return <span className={`btn sec ${size}`} aria-busy="true"><Spinner label="Working" /></span>;
  if (state === "applied") {
    return (
      <button type="button" className="pill p-amber" style={{ cursor: "pointer" }} onClick={onPress} data-testid={testId} title="Withdraw application" aria-label="Applied. Withdraw application">
        Applied <Icon name="x" size={12} />
      </button>
    );
  }
  return <Button size={size} onClick={onPress} data-testid={testId}>Apply</Button>;
}
